import { useEffect } from 'react';
import Meta from '../components/common/Meta';
import RedesignPageLayout from '../components/common/RedesignPageLayout';
import { scrollToHash } from '../utils/ScrollUtil';
import { ScrollArea, Text } from '@radix-ui/themes';

const meta = {
    title: '关于本站 - 博客中心',
    keywords: '博客中心, 独立博客, 个人博客, 博客收录, 博客聚合, 中文博客, 博客导航, RSS订阅, 博客圈子, 技术博客, 生活博客, 博客推荐, 博客发现, 原创内容, 知识分享',
    description: '博客中心是专业的中文独立博客收录聚合平台，汇聚优质个人博客，支持RSS订阅和博客发现。',
};

export default function AboutPage() {
    useEffect(() => {
        scrollToHash();
    });

    return (
        <>
            <Meta meta={meta} />
            <RedesignPageLayout>
                <div className="redesign-split-layout">
                    <div className="redesign-split-main">
                        <header className="redesign-page-header">
                            <h1 className="redesign-page-title">关于本站</h1>
                            <p className="redesign-page-desc">
                                了解博客中心的收录规则、数据采集方式与联系方式。
                            </p>
                        </header>
                        <article className="redesign-article">
                            <p>您好，欢迎来到博客中心！</p>
                            <p>博客中心成立于 2025 年 8 月，旨在打造一个独立博客人专属的博客平台！</p>

                            <h4 id="submit-blog">提交博客</h4>
                            <p>若您想申请自己的博客被本站收录，请先确认您的博客满足如下要求：</p>
                            <ul>
                                <li>基础要求：仅限个人独立博客；</li>
                                <li>内容要求：满足我国法律法规要求，勿含有政治、色情、赌博、暴力等内容；</li>
                                <li>原创要求：原创文章数占总文章数比例不少于 80%；</li>
                                <li>站龄要求：建站已有6个月或以上；</li>
                                <li>RSS 要求：拥有可以访问的 RSS 地址（如：<a href="https://bokehub.com/feed.xml">https://bokehub.com/feed.xml</a>）</li>
                            </ul>
                            <p>确认满足如上要求并承诺长期不关闭博客站点，可以通过点击导航栏「<a href="/blog-requests/add">提交博客</a>」按钮来填写申请表单，提交后一般在 24 小时内会得到审核，审核通过或未通过都会收到邮件提醒。</p>

                            <h4 id="del-link">修改博客</h4>
                            <p>若您因域名更换、站点重建等各种原因，想对已收录的博客信息进行修改，请使用能证明您是博客所有者的邮箱联系我们，信息修改成功后会收到邮件通知！</p>
                            <p>若您因任何原因，不想自己的博客被博客中心收录，也可以联系我们进行删除，博客删除成功后也会收到邮件通知！</p>

                            <h4 id="add-link">添加链接</h4>
                            <p>希望您在收到博客通过审核的邮件通知后，将博客中心链接添加到您博客的适当位置，以让更多的博客人发现我们这个圈子！</p>
                            <ul>
                                <li>站名：博客中心</li>
                                <li>网址：<a href="https://bokehub.com/home">https://bokehub.com/home</a></li>
                                <li>网站图标：<a href="https://bokehub.com/assets/images/sites/logo/logo-small.png">https://bokehub.com/assets/images/sites/logo/logo-small.png</a></li>
                                <li>描述：这里是博客世界的中心，更是思想的回声谷。在这里，让每一次阅读都充满惊喜。</li>
                            </ul>

                            <h4 id="data-spider">数据采集</h4>
                            <p>为了在本站聚合展示最新博文，本站会对已收录的博客定时进行数据采集，采集 URL 为博客的 RSS 地址，采集频率为 1 小时 1 次。</p>
                            <ScrollArea scrollbars="horizontal">
                                <Text size="2">Mozilla/5.0 (compatible; BokeHubSpider/1.0; +https://bokehub.com/about#data-spider)</Text>
                            </ScrollArea>

                            <h4 id="subscribe-feed">文章订阅</h4>
                            <ul>
                                <li>最新文章 RSS：<a href="https://bokehub.com/feed.xml?sort=latest">https://bokehub.com/feed.xml?sort=latest</a></li>
                            </ul>

                            <h4 id="contact-admin">联系站长</h4>
                            <ul>
                                <li>邮箱地址：<a href="mailto:bokehub@qq.com">bokehub@qq.com</a></li>
                            </ul>
                            <p>最后，愿独立博客可以走得更远！</p>
                        </article>
                    </div>
                    <aside className="redesign-illustration-aside" aria-hidden="true">
                        <figure className="redesign-art-print">
                            <img
                                src="/assets/images/sites/redesign/about-bg.png"
                                alt=""
                            />
                        </figure>
                    </aside>
                </div>
            </RedesignPageLayout>
        </>
    );
}
